export default "__VITE_ASSET__Bo2g9Lex__"